module.exports = __webpack_public_path__ + "static/media/login_start.e6ffb4f8.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/login_start.png
// module id = 1162
// module chunks = 0